<script lang="ts" setup>
type TitleSize = "s" | "m" | "l" | "xl";

const {
  tag = "h1",
  size = "m",
  weight = "light",
  withMargin = false,
} = defineProps<{
  text?: string;
  tag?: "h1" | "h2";
  size?: TitleSize;
  weight?: "light" | "semibold";
  withMargin?: boolean;
}>();
</script>

<template>
  <component
    :is="tag"
    :data-size="size"
    :data-weight="weight"
    :data-with-margin="withMargin"
  >
    <slot>
      {{ text }}
    </slot>
  </component>
</template>

<style scoped>
@import "Title.css";
</style>
